import { baseUrl } from '@constants/URLs';
import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PageFooter.module.scss';

export function PageFooter({ className, ...rest }: ComponentProps<'footer'>) {
  const { t: i18n } = useTranslation();

  return (
    <footer className={classNames(styles.footer, className)} {...rest}>
      <span>
        {i18n('navigation:poweredBy')} <a href={baseUrl}>Partful</a>
      </span>
      <span>{i18n('navigation:copyright', { year: new Date().getFullYear() })}</span>
    </footer>
  );
}
